export interface StorageItem<T> {
  payload: T;
  expires: Date;
}

export class Storage {
  static get<T>(key: string) {
    const str = localStorage.getItem('hub_' + key);
    if (str) {
      let item: StorageItem<T>;
      try {
        item = JSON.parse(atob(str));
      } catch {
        return;
      }
      if (new Date(item.expires) > new Date()) {
        return item.payload;
      }
    }
  }

  static set(key: string, payload: any, expires?: Date) {
    const value = JSON.stringify({ payload, expires });
    localStorage.setItem('hub_' + key, btoa(value));
  }

  static remove(key: string) {
    localStorage.removeItem('hub_' + key);
  }

  static clear() {
    localStorage.clear();
  }
}
